import React, { useState, useEffect } from 'react';
import './styles/global.css';
import { AuthProvider } from './context/AuthContext';
import Sidebar from './components/Sidebar';
import BottomNav from './components/BottomNav';
import UserButton from './components/UserButton'; 
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import { LanchPage } from './pages/LanchPage';
import { BarPage } from './pages/BarPage';
import ReviewsPage from './pages/ReviewsPage'; 
import OfertaPage from './pages/OfertaPage';
import PrivacyPage from './pages/PrivacyPage';
import CookiePage from './pages/CookiePage';
import api from './api';

function useIsMobile() {
  const [v, setV] = useState(window.innerWidth < 768);
  useEffect(() => {
    const fn = () => setV(window.innerWidth < 768);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);
  return v;
}

const getDishWord = (num) => {
  const n = Math.abs(num) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) return 'страв';
  if (n1 > 1 && n1 < 5) return 'страви';
  if (n1 === 1) return 'страва';
  return 'страв';
};

// --- ІКОНКИ ---
const PremiumHeart = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
  </svg>
);

const PremiumStar = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#d4af37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
  </svg>
);

const DocumentIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#8b6914" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
);

const ShieldIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4a7c59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
  </svg>
);

const CookieIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#b5762e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"></path>
    <path d="M8.5 8.5v.01"></path>
    <path d="M16 15.5v.01"></path>
    <path d="M12 12v.01"></path>
    <path d="M11 17v.01"></path>
    <path d="M7 14v.01"></path>
  </svg>
);

const ChevronRight = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
);

// --- COOKIE BANNER ---
function CookieBanner({ onNavigateCookie }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 10000,
      background: 'rgba(13,13,11,0.97)',
      backdropFilter: 'blur(10px)',
      borderTop: '1px solid rgba(212,175,55,0.25)',
      padding: '18px 24px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: 20, flexWrap: 'wrap',
      boxShadow: '0 -8px 32px rgba(0,0,0,0.3)',
      animation: 'cookieSlideUp 0.4s ease forwards',
    }}>
      <div style={{ flex: 1, minWidth: 240, color: '#f0ece3' }}>
        <p style={{ fontSize: 14, fontWeight: 500, marginBottom: 4 }}>
          Ми використовуємо файли cookie на цьому сайті, щоб покращити ваш досвід використання
        </p>
        <p style={{ fontSize: 12.5, color: 'rgba(240,236,227,0.6)' }}>
          Натискаючи кнопку «Прийняти», ви погоджуєтесь з нами.{' '}
          <span
            onClick={onNavigateCookie}
            style={{ color: '#e8c97e', textDecoration: 'underline', cursor: 'pointer' }}
          >
            Розширена інформація
          </span>
        </p>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
        <button onClick={handleAccept} style={{
          padding: '12px 28px', borderRadius: 30, border: 'none',
          background: 'linear-gradient(135deg, #e8c97e 0%, #d4af37 100%)',
          color: '#0d0d0b', fontWeight: 600, fontSize: 14, cursor: 'pointer',
          transition: 'all 0.2s', whiteSpace: 'nowrap',
        }}
          onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
        >
          Прийняти
        </button>
        <button onClick={handleDecline} style={{
          padding: '12px 20px', borderRadius: 30,
          border: '1px solid rgba(240,236,227,0.2)',
          background: 'transparent', color: 'rgba(240,236,227,0.7)',
          fontWeight: 500, fontSize: 14, cursor: 'pointer',
          transition: 'all 0.2s', whiteSpace: 'nowrap',
        }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(240,236,227,0.4)'; e.currentTarget.style.color = '#f0ece3'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(240,236,227,0.2)'; e.currentTarget.style.color = 'rgba(240,236,227,0.7)'; }}
        >
          Ні, дякую
        </button>
      </div>

      <style>{`
        @keyframes cookieSlideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
}

// --- DRAWER ITEM КОМПОНЕНТ ---
function DrawerItem({ onClick, iconBg, icon, title, subtitle }) {
  return (
    <button onClick={onClick} style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '20px', background: '#fff', borderRadius: 20,
      border: 'none', cursor: 'pointer',
      boxShadow: '0 8px 24px rgba(0,0,0,0.04)', transition: 'all 0.2s', width: '100%'
    }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.08)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.04)'; }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div style={{ width: 48, height: 48, borderRadius: '50%', background: iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {icon}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
          <span style={{ fontFamily: "'Fraunces', serif", fontSize: 18, color: '#0d0d0b', fontWeight: 500 }}>{title}</span>
          <span style={{ fontSize: 13, color: '#6b6560', fontWeight: 400 }}>{subtitle}</span>
        </div>
      </div>
      <div style={{ color: '#c8b89a' }}><ChevronRight /></div>
    </button>
  );
}

// --- ГЛОБАЛЬНИЙ DRAWER ---
function GlobalDrawer({ isOpen, onClose, onNavigateFavorites, onNavigateReviews, onNavigateOferta, onNavigatePrivacy, onNavigateCookie }) {
  const isMobile = useIsMobile();
  const [favCount, setFavCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const loadFavs = () => {
    setLoading(true);
    api.get('/dishes')
      .then(r => {
        const liked = r.data.filter(d => localStorage.getItem(`liked_${d.id}`) === 'true');
        setFavCount(liked.length);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { if (isOpen) loadFavs(); }, [isOpen]);
  useEffect(() => {
    window.addEventListener('likeUpdated', loadFavs);
    return () => window.removeEventListener('likeUpdated', loadFavs);
  }, []);

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      display: 'flex', justifyContent: 'flex-end',
      background: 'rgba(0, 0, 0, 0.6)',
      backdropFilter: 'blur(4px)',
    }} onClick={onClose}>
      <div style={{
        width: isMobile ? '100%' : 420, height: '100%',
        background: '#fcfbf9',
        boxShadow: '-12px 0 40px rgba(0,0,0,0.2)',
        display: 'flex', flexDirection: 'column', position: 'relative',
        animation: 'slideIn 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) forwards',
      }} onClick={e => e.stopPropagation()}>

        <div style={{ padding: '28px 24px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ fontFamily: "'Fraunces', serif", fontSize: 28, color: '#0d0d0b', fontWeight: 500 }}>
            Навігація
          </div>
          <button onClick={onClose} style={{
            width: 40, height: 40, borderRadius: '50%', background: 'transparent', border: '1px solid #e8ddd0',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#0d0d0b', cursor: 'pointer', transition: 'all 0.2s'
          }}
            onMouseEnter={e => e.currentTarget.style.background = '#f4ece1'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '12px 24px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          
          <DrawerItem
            onClick={onNavigateFavorites}
            iconBg="#fff5f5"
            icon={<PremiumHeart />}
            title="Обране"
            subtitle={loading ? 'Оновлення...' : `${favCount} ${getDishWord(favCount)}`}
          />

          <DrawerItem
            onClick={onNavigateReviews}
            iconBg="#fdf9ee"
            icon={<PremiumStar />}
            title="Відгуки"
            subtitle="Враження клієнтів"
          />

          <div style={{ height: 1, background: '#e8ddd0', margin: '4px 0' }} />

          <DrawerItem
            onClick={onNavigateOferta}
            iconBg="#fef9ee"
            icon={<DocumentIcon />}
            title="Договір оферти"
            subtitle="Умови купівлі-продажу"
          />

          <DrawerItem
            onClick={onNavigatePrivacy}
            iconBg="#f0f7f2"
            icon={<ShieldIcon />}
            title="Політика конфіденційності"
            subtitle="Захист персональних даних"
          />

          <DrawerItem
            onClick={onNavigateCookie}
            iconBg="#fdf3e8"
            icon={<CookieIcon />}
            title="Політика використання cookie"
            subtitle="Файли cookie на сайті"
          />

        </div>

        <div style={{ padding: '16px 24px', borderTop: '1px solid #e8ddd0', display: 'flex', alignItems: 'center', gap: 12 }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 26" style={{ height: 20 }}>
            <rect width="80" height="26" rx="4" fill="white"/>
            <text x="8" y="20" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="22" fill="#1A1F71" letterSpacing="1">VISA</text>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 24" style={{ height: 28 }}>
            <rect width="38" height="24" rx="4" fill="#f0f0f0"/>
            <circle cx="15" cy="12" r="7" fill="#EB001B"/>
            <circle cx="23" cy="12" r="7" fill="#F79E1B"/>
            <path d="M19 6.8a7 7 0 0 1 0 10.4A7 7 0 0 1 19 6.8z" fill="#FF5F00"/>
          </svg>
        </div>
      </div>

      <style>{`
        @keyframes slideIn {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
      `}</style>
    </div>
  );
}

// --- ГОЛОВНИЙ APP ---
export default function App() {
  const [activeTab, setActiveTab] = useState('home');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [targetCategory, setTargetCategory] = useState(null); 
  const isMobile = useIsMobile();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const dishId = params.get('dish');
    if (dishId) {
      api.get('/dishes')
        .then(r => {
          const dish = r.data.find(d => String(d.id) === dishId);
          if (dish) {
            const cat = String(dish.category_id);
            if (['9', '10'].includes(cat)) setActiveTab('bar');
            else if (cat === '8') setActiveTab('lanch');
            else setActiveTab('menu');
          }
        })
        .catch(err => console.log('Не вдалося знайти страву', err));
    }
  }, []);

  const handleGoToFavorites = () => {
    sessionStorage.setItem('goToFavs', 'true');
    setActiveTab('menu');
    setIsDrawerOpen(false);
    window.dispatchEvent(new Event('showFavorites'));
  };

  const handleGoToReviews = () => { setActiveTab('reviews'); setIsDrawerOpen(false); };
  const handleGoToOferta = () => { setActiveTab('oferta'); setIsDrawerOpen(false); };
  const handleGoToPrivacy = () => { setActiveTab('privacy'); setIsDrawerOpen(false); };
  const handleGoToCookie = () => { setActiveTab('cookie'); setIsDrawerOpen(false); };

  const scrollableTabs = ['oferta', 'privacy', 'cookie', 'reviews'];
  const isScrollable = scrollableTabs.includes(activeTab);

  const Page = () => {
    if (activeTab === 'home') return (
      <HomePage onNavigate={(tab, categoryId) => {
        setActiveTab(tab);
        setTargetCategory(categoryId || null);
      }} />
    );
    if (activeTab === 'lanch') return <LanchPage cart={{}} onAdd={() => {}} />;
    if (activeTab === 'bar') return <BarPage cart={{}} onAdd={() => {}} />;
    if (activeTab === 'reviews') return <ReviewsPage />;
    if (activeTab === 'oferta') return <OfertaPage />;
    if (activeTab === 'privacy') return <PrivacyPage />;
    if (activeTab === 'cookie') return <CookiePage />;
    return <MenuPage cart={{}} onAdd={() => {}} initialCategory={targetCategory} />;
  };

  const drawerProps = {
    isOpen: isDrawerOpen,
    onClose: () => setIsDrawerOpen(false),
    onNavigateFavorites: handleGoToFavorites,
    onNavigateReviews: handleGoToReviews,
    onNavigateOferta: handleGoToOferta,
    onNavigatePrivacy: handleGoToPrivacy,
    onNavigateCookie: handleGoToCookie,
  };

  const menuButton = (
    <button onClick={() => setIsDrawerOpen(true)} style={{
      background: 'transparent', border: 'none', color: '#fff',
      cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line>
      </svg>
    </button>
  );

  if (isMobile) {
    return (
      <AuthProvider>
        <div style={{ display: 'flex', flexDirection: 'column', height: '100dvh', overflow: 'hidden', background: 'var(--paper)' }}>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '11px 16px 9px', background: 'var(--ink)', flexShrink: 0,
          }}>
            <div style={{ fontFamily: "'Fraunces', serif", fontSize: 16, fontWeight: 300, color: '#fff' }}>
              Ресторан{' '}
              <em style={{ color: 'var(--highlight)', fontStyle: 'italic' }}>«Околиця»</em>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
              {menuButton}
              <UserButton />
            </div>
          </div>
          <main style={{ flex: 1, overflow: isScrollable ? 'auto' : 'hidden', display: 'flex', flexDirection: 'column' }}>
            <Page />
          </main>
          <BottomNav activeTab={activeTab} onTabChange={setActiveTab} />
        </div>
        <GlobalDrawer {...drawerProps} />
        <CookieBanner onNavigateCookie={handleGoToCookie} />
      </AuthProvider>
    );
  }

  return (
    <AuthProvider>
      <div style={{ position: 'relative', height: '100vh', background: '#f5f5f5' }}>
        <div style={{
          display: 'flex', height: '100vh', overflow: 'hidden',
          width: '100%', maxWidth: 'min(1800px, calc(100vw - 48px))', margin: '0 auto',
          boxShadow: '0 0 60px rgba(0,0,0,0.08)', background: '#fff'
        }}>
          <Sidebar activeTab={activeTab} onTabChange={setActiveTab} />
          <main style={{ flex: 1, overflow: isScrollable ? 'auto' : 'hidden', display: 'flex', flexDirection: 'column', position: 'relative' }}>
            <button onClick={() => setIsDrawerOpen(true)} style={{
              position: 'absolute', top: 24, right: 32, zIndex: 50,
              width: 46, height: 46, borderRadius: '50%',
              background: '#fff', border: '1px solid #ddd5c8',
              boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', transition: 'all 0.2s', color: '#0d0d0b'
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.1)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.06)'; }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </button>
            <Page />
          </main>
        </div>
        <GlobalDrawer {...drawerProps} />
        <CookieBanner onNavigateCookie={handleGoToCookie} />
      </div>
    </AuthProvider>
  );
}
